import { SelectionChangedEvent } from "ag-grid-community";
import { INITIAL_VESSEL_COL_DEF, INITIAL_VESSEL_WITH_CNTR_COL_DEF, transferCntrRowData, transferRowData } from "presentation/constant/ChargeDetailMaintenance/UpdateChargeVesselColumnDefinition";
import { useChargeVesselVM } from "presentation/hook/ChargeDetailMaintenance/useChargeVesselVM copy";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { useCallback, useMemo, useRef, useState } from "react";
import { ChargeDetailConstant } from "presentation/constant/ChargeDetailMaintenance/ChargeDetailConstant";
import DatePickerComponent from "presentation/view/components/DatePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { FieldType, HPHButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import { WorkspaceConstant } from "presentation/constant/WorkSpaceConstant";
import { ChangeActionOptionPolicy } from "constants/charge/ChangeActionOptionPolicy";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { VoyageFinalizedIndDroOpts } from "presentation/constant/DropDownOptions/Charge/VoyageFinalizedIndDroOpts";
import { stateDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";

export const UpdateChargeVesselTablePanel = ({ chargeDetailState, updateStatusType }:
    { chargeDetailState: ChargeDetailModel, updateStatusType: string }) => {
    const chargeDetailVM = useChargeDetailVM();
    const chargeVesselVM = useChargeVesselVM();
    const tableId = 'charge-vessel-table';
    const gridRef: any = useRef();
    const cntrGridRef: any = useRef();
    const chargeConstant = ChargeDetailConstant.Charge;
    const { chargeVesselSearchCriteria, selectedChargeVessels, chargeBatchUpdate } = chargeDetailState;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [anaInfoState] = useANAInfoTracked();
    const { allowUpdate } = anaInfoState;

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        chargeVesselVM.updateSelectedVslVoys(selectedRows);
    }, [chargeVesselVM])

    // useEffect(() => {
    //     if (!onTableSelectionClicked) return;
    //     gridRef.current?.gridRef.current.api?.deselectAll();
    //     cntrGridRef.current?.gridRef.current.api?.deselectAll();
    // }, [onTableSelectionClicked])

    const handleApply = useCallback(async () => {
        chargeVesselVM.onFieldChange({
            'consortiumCode': selectedChargeVessels[0].consortiumCode,
            'vesselCode': selectedChargeVessels[0].vesselCode,
            'voyageCode': selectedChargeVessels[0].voyageCode
        }, chargeBatchUpdate, "chargeBatchUpdate");
        chargeVesselVM.addDummyVesselInfo(selectedChargeVessels[0]);
        chargeDetailVM.closeVesselPanel();
    }, [chargeBatchUpdate, chargeDetailVM, chargeVesselVM, selectedChargeVessels]);

    const handleReset = useCallback(async () => {
        chargeVesselVM.onResetButtonClicked();
    }, [chargeVesselVM]);

    const isDisableApply = () => {
        return selectedChargeVessels.length === 1;
    }

    const handleSearch = useCallback(async () => {
        setIsLoading(true);
        let newChargeVesselSearchCriteria = {
            ...chargeVesselSearchCriteria,
            changeActionOption: chargeBatchUpdate.operationTypeIndex,
            updateStatusType: updateStatusType,
        }
        chargeVesselVM.searchChargeDetailDynStatus(newChargeVesselSearchCriteria).then((data) => {
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
        }).finally(() => {
            setIsLoading(false);
        });
    }, [chargeVesselSearchCriteria, chargeBatchUpdate.operationTypeIndex, updateStatusType, chargeVesselVM]);

    // const onDateChange = useCallback((filedName: string, date: any) => {
    //     chargeVesselVM.onDateChange(filedName, date, chargeVesselSearchCriteria, "chargeVesselSearchCriteria");
    // }, [chargeVesselSearchCriteria, chargeVesselVM]);


    const memoConCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "15px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeVesselSearchCriteria?.consortiumCode || ''}
                fieldValue={chargeVesselSearchCriteria?.consortiumCode}
                fieldLabel={chargeConstant.CONSORTIUM_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'consortiumCode'}
                maxLength={60}
                isTextFieldCapitalize={true}
                sort={false}
                options={chargeDetailState.dynamicOptions.consortiumCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeVesselVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [chargeConstant.CONSORTIUM_CODE, chargeDetailState.dynamicOptions.consortiumCodeDropdownOptions, chargeVesselSearchCriteria?.consortiumCode, chargeVesselVM])

    const memoVslCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeVesselSearchCriteria?.vesselCode || ''}
                fieldValue={chargeVesselSearchCriteria?.vesselCode}
                fieldLabel={chargeConstant.VESSEL_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'vesselCode'}
                maxLength={6}
                isTextFieldCapitalize={true}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeVesselVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [chargeConstant.VESSEL_CODE, chargeVesselSearchCriteria?.vesselCode, chargeVesselVM])

    const memoVoyCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeVesselSearchCriteria?.voyageCode || ''}
                fieldValue={chargeVesselSearchCriteria?.voyageCode}
                fieldLabel={chargeConstant.VOYAGE_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'voyageCode'}
                maxLength={10}
                isTextFieldCapitalize={true}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeVesselVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [chargeConstant.VOYAGE_CODE, chargeVesselSearchCriteria?.voyageCode, chargeVesselVM])

    // const memoCoVslVoy = useMemo(() =>
    //     <div className='im-flex-row-item'>
    //         <HPHInputMask
    //             label={chargeConstant.CO_VSL_VOY}
    //             width="300px"
    //             value={{
    //                 co: chargeVesselSearchCriteria.consortiumCode ?? '',
    //                 vsl: chargeVesselSearchCriteria.vesselCode ?? '',
    //                 voy: chargeVesselSearchCriteria.voyageCode ?? ''
    //             }}
    //             fieldConfiguration={{
    //                 co: { maxLength: 4, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
    //                 vsl: { maxLength: 10, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
    //                 voy: { maxLength: 10, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
    //             }}
    //             onDataChange={(e: any) => chargeVesselVM.onCoVslVoyChange(e, {
    //                 co: 'consortiumCode',
    //                 vsl: 'vesselCode',
    //                 voy: 'voyageCode'
    //             })} />
    //     </div>
    //     , [chargeVesselSearchCriteria.consortiumCode, chargeVesselSearchCriteria.vesselCode, chargeVesselSearchCriteria.voyageCode,
    //         chargeVesselVM, chargeConstant.CO_VSL_VOY])

    const memoArrivalDateTime = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px" }}>
            <DatePickerComponent
                // disabled={isRead}
                label={ChargeDetailConstant.Vessel.ARR_DATE_TIME}
                width="180px"
                date={chargeVesselSearchCriteria?.etb}
                fieldName="etb"
                errorMessage={""}
                onDateChange={(fieldKey: string, fieldValue: IFieldValue) =>
                    chargeVesselVM.onSearchFieldChange(fieldKey, fieldValue)} />
        </div>
        , [chargeVesselSearchCriteria?.etb, chargeVesselVM])

    const memoDepatureDateTime = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px" }}>
            <DatePickerComponent
                // disabled={isRead}
                label={ChargeDetailConstant.Vessel.DEP_DATE_TIME}
                width="180px"
                date={chargeVesselSearchCriteria?.etd}
                fieldName="etd"
                errorMessage={""}
                onDateChange={(fieldKey: string, fieldValue: IFieldValue) =>
                    chargeVesselVM.onSearchFieldChange(fieldKey, fieldValue)} />
        </div>
        , [chargeVesselSearchCriteria?.etd, chargeVesselVM])

    const memoOpertingTml = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "15px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeVesselSearchCriteria?.operatingTml || ''}
                fieldValue={chargeVesselSearchCriteria?.operatingTml}
                fieldLabel={chargeConstant.OPERATING_TML}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'operatingTml'}
                maxLength={60}
                options={chargeDetailState.dynamicOptions.operatingTmlDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeVesselVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [chargeConstant.OPERATING_TML, chargeVesselVM, chargeVesselSearchCriteria?.operatingTml, chargeDetailState.dynamicOptions.operatingTmlDropdownOptions])

    const memoServiceCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "15px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeVesselSearchCriteria?.serviceCode || ''}
                fieldValue={chargeVesselSearchCriteria?.serviceCode}
                fieldLabel={chargeConstant.SERVICE_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'serviceCode'}
                maxLength={60}
                options={chargeDetailState.dynamicOptions.serviceCodeOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeVesselVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [chargeConstant.SERVICE_CODE, chargeVesselVM, chargeVesselSearchCriteria?.serviceCode, chargeDetailState.dynamicOptions.serviceCodeOptions])

    const memoState = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "15px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeVesselSearchCriteria?.state || ''}
                fieldValue={chargeVesselSearchCriteria?.state}
                fieldLabel={chargeConstant.STATE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'state'}
                maxLength={60}
                options={stateDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeVesselVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [chargeConstant.STATE, chargeVesselVM, chargeVesselSearchCriteria?.state])

    const memoFinalizedInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "15px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={updateStatusType === ChangeActionOptionPolicy.chargeType.CHANGE_TYPE_3}
                isShowOptional={false}
                readOnlyValue={chargeVesselSearchCriteria?.finalized || ''}
                fieldValue={chargeVesselSearchCriteria?.finalized}
                fieldLabel={ChargeDetailConstant.Vessel.FINALIZED_IND}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'finalized'}
                maxLength={60}
                options={VoyageFinalizedIndDroOpts().getDroOptsModel()}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeVesselVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [updateStatusType, chargeVesselSearchCriteria?.finalized, chargeVesselVM])

    const memoVesselTable = useMemo(() => {
        return (
            <NbisTable
                id={tableId}
                isNewColumnSetting={true}
                columns={INITIAL_VESSEL_COL_DEF?.slice()}
                data={transferRowData(chargeDetailState.chargeVessels) ?? []}
                showPaginator={false}
                editable={false}
                rowSelection={"single"}
                isRowHighligted={true}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                handleSelectionChanged={handleSelectionChange}
                gridHeight="customHeight"
                customHeight="calc(38vh)"
                ref={gridRef}
            />

        );
    }, [chargeDetailState.chargeVessels, handleSelectionChange])


    const memoVesselWithCntrTable = useMemo(() => {
        return (
            <NbisTable
                id={`${tableId}_with_cntr`}
                isNewColumnSetting={true}
                columns={INITIAL_VESSEL_WITH_CNTR_COL_DEF?.slice()}
                data={transferCntrRowData(chargeDetailState.chargeVessels) ?? []}
                showPaginator={false}
                editable={false}
                rowSelection={"single"}
                isRowHighligted={true}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                handleSelectionChanged={handleSelectionChange}
                gridHeight="customHeight"
                customHeight="calc(38vh)"
                ref={cntrGridRef}
            />

        );
    }, [chargeDetailState.chargeVessels, handleSelectionChange])

    return <>
        <Sidebarheader style={{ width: '100%' }}>
            <div className={'add-edit-form'} style={{ height: '20vh', maxHeight: '20vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <CriteriaItemContainer>
                            {memoOpertingTml}
                            {memoServiceCode}
                            {memoConCode}
                            {memoState}
                            {memoFinalizedInd}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoVslCode}
                            {memoVoyCode}
                            {memoArrivalDateTime}
                            {memoDepatureDateTime}
                        </CriteriaItemContainer>
                    </div>
                </div>
            </div>
        </Sidebarheader>
        <StyledAction className="tm-animated-wrapper">
            {<HPHButton disabled={false} label={WorkspaceConstant.Common.BUTTON_RESET} size={'Small'} theme={'Secondary'} onClick={handleReset} />}
            {<HPHButton disabled={false} label={WorkspaceConstant.Common.BUTTON_SEARCH} size={'Small'} theme={'Primary'} onClick={handleSearch} />}
        </StyledAction>
        {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
        {((updateStatusType === ChangeActionOptionPolicy.chargeType.CHANGE_TYPE_2 && chargeBatchUpdate.operationTypeIndex === 2) ||
            (updateStatusType === ChangeActionOptionPolicy.chargeType.CHANGE_TYPE_3 && chargeBatchUpdate.operationTypeIndex === 1)) ?
            <>{memoVesselWithCntrTable}</> : <>{memoVesselTable}</>
        }
        {<StyledAction className="tm-animated-wrapper">
            {(allowUpdate) && <HPHButton disabled={!isDisableApply()} label={WorkspaceConstant.Common.BUTTON_UPDATE} size={'Small'} theme={'Primary'} onClick={handleApply} />}
        </StyledAction>}
    </>;
}